import axios from "axios";
import { CORREO_USUARIO } from "config/general/Configuracion";
import { API_CONFIGURACION } from "config/general/Configuracion";
import { ID_CUENTA } from "config/general/Configuracion";
import { HEADERS, apiTimeout } from "config/general/Configuracion";


const DispositivosPermitidosApiHelper = {

    listarDispositivosPermitidos: async () => {
        try {
            const url = `${API_CONFIGURACION}/v1/configuracion/listar_dispositivos_permitidos/${sessionStorage[ID_CUENTA]}`;
            const response = await axios.get(url, {
                headers: HEADERS(),
                timeout: apiTimeout
            });
            return response.data;
        } catch (error) {
            console.error("Error al listar dispositivos permitidos:", error);
            throw error;
        }
    },

    guardarDispositivoPermitido: async (dispositivo) => {
        try {
            const url = `${API_CONFIGURACION}/v1/configuracion/guardar_dispositivo_permitido/${sessionStorage[ID_CUENTA]}`;
            const response = await axios.post(url, dispositivo, {
                headers: HEADERS(),
                timeout: apiTimeout
            });
            return response.data;
        } catch (error) {
            console.error("Error al guardar dispositivo permitido:", error);
            throw error;
        }
    },

};

export default DispositivosPermitidosApiHelper;
